import script from "./AboutHelpComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutHelpComponent.vue?vue&type=script&setup=true&lang=js"

import "./AboutHelpComponent.vue?vue&type=style&index=0&id=aa298aea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa298aea"]])

export default __exports__